/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dragHelper = _interopRequireDefault(require("@inovua/reactdatagrid-community/packages/drag-helper"));
var emptyFn = function emptyFn() {};
var setupRowDrag = function setupRowDrag(event, region, cfg) {
  var _onDrag = cfg.onDrag || emptyFn;
  var _onDrop = cfg.onDrop || emptyFn;
  var mobile = !!(event.type === 'touchstart');
  (0, _dragHelper.default)(event, {
    region: region,
    onDrag: function onDrag(event, config) {
      if (event.cancelable) {
        event.preventDefault();
      }
      _onDrag(event, config);
    },
    onDrop: function onDrop(event, config) {
      _onDrop(event, config);
    },
    mobile: mobile
  });
};
var _default = setupRowDrag;
exports.default = _default;